export var OUTDATED_TEMPLATE = 'basic';
export var HORIZONTAL_TEMPLATE = 't1';
export var VERTICAL_TEMPLATE = 't2';
export var DEFAULT_THEME = 'pure';
export var DEFAULT_HAS_FOOTER = true;
export var DEFAULT_VIDEO_RATIO = 16 / 9;
export var DATA_WRAPPER_WIDTH = 720;
export var DESKTOP_BREAKPOINT = 992;
export var DEFAULT_THUMBNAIL_WIDTH = 320;
export var ALL_THEMES = ['pure', 'daisy', 'dawn', 'deep', 'dew', 'dusk', 'lily', 'mist', 'night', 'pale', 'peony', 'sand'];
export var DEFAULT_MOBILE_WIDTH = 375;
export var DEFAULT_MOBILE_HEIGHT = 812;
export var DESKTOP_FOOTER_HEIGHT = 120;
export var MOBILE_FOOTER_HEIGHT = 80;
export var DEFAULT_VIEW_TYPE = 'fit';